import { colorSystem } from "goi_common";

const title = "강원 장례 정보 - 고이장례연구소";

export const parlorRegion = {
  defaultMetaData: {
    pageOgTitle: title,
    pageDescription: `강원 장례식장 예상 비용, 저렴한 강원 장례식장, 장례 비용 줄이는 방법, 주변 장례식장과 상세 비교 (고이장례연구소)`,
    pageKeywords:
      "강원 장례식장 추천, 춘천 장례식장 추천, 강릉 장례식장 추천, 원주 장례식장 추천, 장례, 장례식, 가족장, 가족 장례, 소규모 장례, 무빈소장례, 장례식장, 장례 비용, 상조, 상조 회사, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    pageOgDescription: `강원 장례식장 예상 비용, 저렴한 강원 장례식장, 장례 비용 줄이는 방법, 주변 장례식장과 상세 비교 (고이장례연구소)`,
    pageOgImage: "",
  },

  layout: {
    headTitle: title,
    layoutStyle: {
      background: "white",
      borderBottom: "1px solid #7d7d7d",
      color: "black",
      height: "55px",
      margin: "0",
    },
    ctaButtonStyle: { border: "none", color: "white", background: colorSystem.red.c400 },
  },

  targetSidos: ["32"],

  regionColor: colorSystem.red,

  bestParlorIds: [24, 104, 161, 815, 1082],

  baseUrl: "https://www.gangwon-portal.co.kr",
};
